'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Button = require('@narvar/nth-block-button');
var TextInput = require('@narvar/nth-block-text-input');
var index$1 = require('../../../components/Language/index.js');
var Spinner = require('../../../components/Spinner/Spinner.js');
require('@babel/runtime/helpers/extends');
var LocationCard = require('../../../components/LocationCard/LocationCard.js');
require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
require('../../../components/SelectList/SelectList.js');
var ErrorBanner = require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
require('../../../components/SwatchesList/SwatchesList.js');
var index = require('../../../components/TextLink/index.js');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var LocationPicker_module = require('./LocationPicker.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);

const LocationSearcher = _ref => {
  let {
    postalCode,
    postalCodeError,
    postalCodeValueSubmit,
    sortedBy,
    sortedByOptions,
    sortedByValueChange
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover,
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const [changePostalCodeMode, setChangePostalCodeMode] = React.useState(false);
  const [value, setValue] = React.useState(postalCode);
  const inputRef = React.useRef(null);
  const toggleChange = () => {
    setChangePostalCodeMode(prev => !prev);
  };
  const handleChange = e => {
    setValue(e.target.value);
  };
  const handleSubmit = e => {
    e.preventDefault();
    toggleChange();
    postalCodeValueSubmit === null || postalCodeValueSubmit === void 0 ? void 0 : postalCodeValueSubmit(value);
  };
  const cancel = React.useCallback(() => {
    toggleChange();
    setValue(postalCode);
  }, [postalCode]);
  React.useEffect(() => {
    var _inputRef$current;
    if (!changePostalCodeMode) return;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }, [changePostalCodeMode]);
  React.useEffect(() => {
    setValue(postalCode);
  }, [postalCode]);
  React.useEffect(() => {
    const handleKeyDown = event => {
      if (!changePostalCodeMode) return;
      if (inputRef.current !== document.activeElement) return;
      if (event.key === 'Escape') cancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.addEventListener('keydown', handleKeyDown);
  }, [changePostalCodeMode, cancel]);
  if (changePostalCodeMode || postalCodeError) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: LocationPicker_module["default"].changePostalCodeWrapper
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: LocationPicker_module["default"].postalCodeUpdate,
      style: {
        fontSize: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontSize) ?? '14px'
      }
    }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      langKey: "returnsPudoLocationsPostalcodeTitle"
    }), /*#__PURE__*/React__default["default"].createElement("form", {
      className: LocationPicker_module["default"].postalCodeForm,
      onSubmit: handleSubmit
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        width: 'auto'
      }
    }, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
      value: value,
      onChange: handleChange,
      inputRef: inputRef
    })), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      type: Button.ButtonType.submit,
      onClick: handleSubmit,
      disabled: !value
    }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      langKey: "returnsPudoLocationsPostalcodeSearch"
    }))), /*#__PURE__*/React__default["default"].createElement(index["default"], {
      onClick: cancel,
      linkStyle: {
        sDefault: linksNoneDefault,
        sHover: linksNoneHover
      }
    }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      langKey: "returnsPudoLocationsPostalcodeCancel"
    }))), postalCodeError && /*#__PURE__*/React__default["default"].createElement("div", {
      className: LocationPicker_module["default"].wrapper
    }, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, postalCodeError)));
  }
  if (!sortedByOptions || sortedByOptions.length < 2) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: LocationPicker_module["default"].postalCodeUpdate,
      style: {
        fontSize: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontSize) ?? '14px'
      }
    }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      langKey: "returnsPudoLocationsPostalcodeTitle"
    }), /*#__PURE__*/React__default["default"].createElement("button", {
      className: LocationPicker_module["default"].postalCodeButton,
      style: linksNoneDefault,
      onClick: toggleChange
    }, postalCode));
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationPicker_module["default"].locationSearcherWrapper
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationPicker_module["default"].postalCodeUpdate,
    style: {
      fontSize: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontSize) ?? '14px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoLocationsPostalcodeTitle"
  }), /*#__PURE__*/React__default["default"].createElement("button", {
    className: LocationPicker_module["default"].postalCodeButton,
    style: linksNoneDefault,
    onClick: toggleChange
  }, postalCode)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationPicker_module["default"].sortByWrapper
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoLocationsSortedbyTitle"
  }), /*#__PURE__*/React__default["default"].createElement("select", {
    className: LocationPicker_module["default"].sortBySelect,
    value: sortedBy,
    onChange: _ref2 => {
      let {
        target: {
          value
        }
      } = _ref2;
      return sortedByValueChange === null || sortedByValueChange === void 0 ? void 0 : sortedByValueChange(value);
    }
  }, sortedByOptions.map(option =>
  /*#__PURE__*/
  // TODO: refactor this instead of disabling
  // eslint-disable-next-line react/jsx-key
  React__default["default"].createElement(index$1["default"], {
    langKey: `returnsPudoLocationsSortedbyOption${option.toLowerCase()}`,
    tagName: "option",
    attributes: {
      key: option,
      value: option
    }
  })))));
};
const LocationPicker = _ref3 => {
  let {
    selectedCategory,
    loading,
    locations,
    onValueChange,
    postalCode,
    postalCodeError,
    postalCodeValueSubmit,
    sortedBy,
    sortedByOptions,
    sortedByValueChange,
    defaultValue,
    showSkip
  } = _ref3;
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  if (loading) return /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationPicker_module["default"].wrapper
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationPicker_module["default"].pudoElmWrap
  }, /*#__PURE__*/React__default["default"].createElement(Spinner["default"], null)));
  if (!selectedCategory) return null;
  if (!(locations !== null && locations !== void 0 && locations.length) && !postalCodeError) return null;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, postalCode && /*#__PURE__*/React__default["default"].createElement(LocationSearcher, {
    postalCode: postalCode,
    postalCodeError: postalCodeError,
    postalCodeValueSubmit: postalCodeValueSubmit,
    sortedBy: sortedBy,
    sortedByOptions: sortedByOptions,
    sortedByValueChange: sortedByValueChange
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationPicker_module["default"].wrapper
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: LocationPicker_module["default"].locationItemWrapper,
    defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.id
  }, locations === null || locations === void 0 ? void 0 : locations.map(location => /*#__PURE__*/React__default["default"].createElement(LocationCard["default"], {
    location: location,
    active: location.id === (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.id),
    key: location.id,
    onValueChange: onValueChange
  }))), showSkip && /*#__PURE__*/React__default["default"].createElement(index["default"], {
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    },
    onClick: () => onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange('')
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoLocationsSkipLink"
  }))));
};
var LocationPicker$1 = nthHookTheme.withThemeProvider(LocationPicker, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover', 'bodytextDefaultNone']
});

exports["default"] = LocationPicker$1;
